const {
  runArrayExtender: baseRunArrayExtender
} = require('vue-js-extender');

exports.runArrayExtender = (Vue) => {
  baseRunArrayExtender(Vue);

  //------------------------- Array Extensions -------------------------
  //------------------------- End -------------------------
};



// WEBPACK FOOTER //
// ./src/core/js-extender/array.extender.js